import Text from "./text";

export { Text };
export default Text;
